import * as React from 'react';

import {exhaustivenessCheck} from 'nutshell-core/typing/exhaustiveness-check';

import type {SignupStartPage} from '../types';

import {SignupCustomHeader} from './signup-custom-header';

type Props = {
    signupStartPage: SignupStartPage;
};

export function SignupStartPageHeader(props: Props) {
    switch (props.signupStartPage) {
        case 'ZENDESK_SELL':
            return (
                <SignupCustomHeader
                    imgSrc={'/client-resources/zendesksell_logo.png'}
                    officialPartner={false}
                />
            );
        case null:
            return null;
        default:
            exhaustivenessCheck(props.signupStartPage);
    }
}
